module.exports = __webpack_public_path__ + "img/silver.b4b645bb.png";